import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../../../../lib/api';

// Premi dell'insegna, tutti gli anni, in sola consultazione.
// Il clic sulla riga apre la pagina Premi Insegna già posizionata su insegna
// e anno, dove si modificano.

interface Premio {
  id: number;
  anno: number;
  tipo: string;
  descrizione: string;
  metodoCalcolo: string;
  scaglioni: { id: number }[];
}

const TIPO_LABEL: Record<string, string> = {
  PFA: 'PFA',
  VOLUMETRICO: 'Volumetrico',
  PROMOZIONALE: 'Promozionale',
  ALTRO: 'Altro',
};

interface Props {
  insegnaId: number;
}

export default function TabPremiInsegna({ insegnaId }: Props) {
  const navigate = useNavigate();
  const [premi, setPremi] = useState<Premio[]>([]);
  const [loading, setLoading] = useState(true);
  const [errore, setErrore] = useState('');

  useEffect(() => {
    let annullato = false;
    (async () => {
      setLoading(true);
      setErrore('');
      try {
        // @api GET /api/anagrafiche/premi-insegna?insegnaClienteId=N -> [{"id":5,"anno":2026,"tipo":"PFA","descrizione":"Premio fine anno","metodoCalcolo":"PROGRESSIVO","scaglioni":[{"id":11}]}]
        const data = await apiFetch<Premio[]>(`/api/anagrafiche/premi-insegna?insegnaClienteId=${insegnaId}`);
        if (!annullato) setPremi(data || []);
      } catch (err: any) {
        if (!annullato) setErrore(err.message || 'Errore nel caricamento dei premi');
      } finally {
        if (!annullato) setLoading(false);
      }
    })();
    return () => { annullato = true; };
  }, [insegnaId]);

  return (
    <div className="bop-card">
      <div className="bop-card__header">
        <h3 className="bop-card__title">Premi</h3>
      </div>
      <div className="bop-card__body">
        {loading ? (
          <div className="bop-empty-state"><p className="bop-empty-state__text">Caricamento…</p></div>
        ) : errore ? (
          <p className="bop-text-danger">{errore}</p>
        ) : premi.length === 0 ? (
          <div className="bop-empty-state">
            <p className="bop-empty-state__text">Nessun premio configurato per questa insegna</p>
          </div>
        ) : (
          <table className="bop-table bop-table--clickable">
            <thead>
              <tr>
                <th>Anno</th>
                <th>Tipo</th>
                <th>Descrizione</th>
                <th>Metodo</th>
                <th className="bop-text-right">Scaglioni</th>
              </tr>
            </thead>
            <tbody>
              {premi.map((p) => (
                <tr key={p.id} onClick={() => navigate(`/anagrafiche/insegne/premi?insegna=${insegnaId}&anno=${p.anno}`)}>
                  <td><strong>{p.anno}</strong></td>
                  <td>{TIPO_LABEL[p.tipo] || p.tipo}</td>
                  <td>{p.descrizione}</td>
                  <td>{p.metodoCalcolo === 'PROGRESSIVO' ? 'Progressivo' : 'Flat'}</td>
                  <td className="bop-text-right">{p.scaglioni.length}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
